const envList = {
  development: {
    BASE_API: 'https://api.kuaipidev.com',
  },
  testing: {
    BASE_API: 'https://api.kuaipitest.com',
  },
  production: {
    BASE_API: 'https://api.kuaipiyun.com',
    isProd: true,
  },
};

const envConfig = envList[API_ENV];

// 如果是在腾讯云流水线上构建，则生产环境使用不同的域名
if (CLOUD_PLATFORM === 'tencent' && envConfig.isProd) {
  envConfig.BASE_API = 'https://api.kuaipicloud.com';
}

export default envList[API_ENV];



// WEBPACK FOOTER //
// ./src/config/index.js